import React from "react"
import { Typography } from "@mui/material"


export default function dateColumn() {
	return {
		name: 'Date from & to',
		render: (_, row) => <Typography sx={{ fontSize: 13 }}>{`From ${row.dateFrom} to ${row.dateTo}`}</Typography>
	}
}